module.exports = __webpack_public_path__ + "static/kh-b3dadd9fb54156c59835b3b65694d075.svg";